<template>
  <router-view />
</template>

<script>
export default {
  name: 'AppLayout'
}
</script>
